module.exports = __webpack_public_path__ + "img/ze-prise.8371ac88.jpg";